import React, { Component } from 'react'
import { connect } from 'react-redux'

import uploadFailurePNG from '@/companys/ttl/assets/images/icons/market_comment_upload_failure.png'
import uploadSuccessPNG from '@/companys/ttl/assets/images/icons/market_comment_upload_success.png'
import close from '@/assets/images/icons/trade_icon_cancel_normal.png'
import picture from '@/companys/ttl/assets/images/icons/market_comment_picture.png'
import pictureLight from '@/companys/ttl/assets/images/icons/market_comment_picture_light.png'
import '@/companys/ttl/assets/styles/components/detail-center/comment_post_dialog.scss'

import Tips from '@/components/Tips/Tips';
import LoadingLayer from '@/components/Spinner/LoadingLayer';

import { userActions } from '@/actions/user';
import { PARAMS } from '@/constants/params.js'
import { WINVEST_PARAMS_JSON_FLAG } from '@/constants/win-vest'
import { LOADING_TYPE } from '@/constants/app';


class CommentPostDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
            Textarea: '',
            commentTitle: '',
            nid: null,
            image: [],
            imageName: [],
            showTextTips: false,
            showImageLimitTips: false,
            showImageSizeTips: false,
            uploadImageload: [false, false, false],
            uploadSuccess: [],
            uploadFailure: [false, false, false],
            buttonLoad: false,
            buttonImgLoad:[],
            attchIndex: 0,
            attchParams: null,
        }
    }
    render() {
        const { language, theme } = this.props
        const { Textarea, image, showTextTips, showImageLimitTips, showImageSizeTips, uploadImageload, uploadSuccess, buttonLoad, uploadFailure,  } = this.state
        return (
            <div className='comment_post_dialog'  >
                <div className='comment_title' >
                    <input   type='text' onChange={e => this.handleTitle(e)} maxlength={20} placeholder={language.market_comment_title}  readOnly={buttonLoad ? 'readonly' : ''} ></input>
                </div>
                <div className='comment_body' >
                    <textarea ref='textArea' className='comment_text' rows="10" cols="30" style={{ resize: 'none' }} maxlength={500} required autofocus defaultValue={Textarea} placeholder={language.market_comment_text_limit}
                        onChange={e => this.handleText(e)} onBlur={() => this.setState({ showTextTips: false })}    readOnly={buttonLoad ? 'readonly' : ''}  ></textarea>
                    {/* <div  contenteditable='true'  suppressContentEditableWarning="true"  className='comment_text'  dangerouslySetInnerHTML = {{ __html: checkMessages.details }} > </div>      */}
                    {/* <div style={{width:'10px' ,height:'10px' ,backgroundColor:'red' }} onClick={() => this.ceshi()} ></div>         */}
                </div>
                <div className='comment_store_picture'>
                    {image?.length > 0 && image.map((item, index) => {
                        return (<div key={index} className='comment_picture' style={{ backgroundImage: `url(${item})` }}>
                            <LoadingLayer type={LOADING_TYPE.SMALL_IMG} load={uploadImageload[index]} ></LoadingLayer>
                            {uploadSuccess[index] && <div className='comment_picture_upload_success_opicity'  >
                                <div className='comment_picture_upload_success' style={{ backgroundImage: `url(${uploadSuccessPNG})` }} ></div>
                            </div>}
                            {uploadFailure[index] && <div className='comment_picture_upload_failure_opacity' >
                                <div className='comment_picture_upload_failure' style={{ backgroundImage: `url(${uploadFailurePNG})` }} > </div>
                            </div>}
                            {!uploadImageload[index] && !uploadSuccess[index] && !uploadFailure[index] && <div className='comment_picture_close' style={{ backgroundImage: `url(${close})` }} onClick={() => this.handleDelectPicture(index)} ></div>}
                        </div>)
                    })}
                    {image?.length > 0 && image?.length < 3 &&  
                        <div className='select_picture'   >
                           { !buttonLoad &&  <input type='file' className='addSelectPicture' id='selectPicture' accept='.jpeg,.jpg,.png' ref={e => this.fileBoxRef = e} onChange={this.handlePictureSelect}  multiple ></input>}
                            <i className='select_picture_add' ></i>
                        </div>}
                </div>
                <div className='comment_select'>
                    <div className='selectPicture' >
                        {image?.length == 3 && <div className='image_length_3' onClick={() => this.setState({ showImageLimitTips: true },()=>{setTimeout(() => {this.setState({showImageLimitTips:false})}, 3000);})} ></div>}
                        <label for='selectPicture'><img src={theme == 'light' ? pictureLight : picture} />{language.market_comment_picture}</label>
                       { !buttonLoad &&  <input type='file' id='selectPicture' accept='.jpeg,.jpg,.png' ref={e => this.fileBtnRef = e} onChange={  this.handlePictureSelect} multiple ></input>}
                    </div>
                    <div className='comment_select_button' >
                        <LoadingLayer type={LOADING_TYPE.SMALL_IMG} load={buttonLoad} ></LoadingLayer>
                        <div className='comment_post_button' onClick={this.getSendPostRequst} >{language.market_comment_post}</div>
                    </div>
                </div>
                <div className='comment_tips' >
                    {showTextTips && <Tips isNoBgColor> {language.market_comment_text_limit}</Tips>}
                    {showImageLimitTips && <Tips isNoBgColor> {language.market_comment_image_num_tips}</Tips>}
                    {showImageSizeTips && <Tips isNoBgColor> {language.market_comment_image_size_tips}</Tips>}
                </div>
            </div>
        )
    }
    componentDidMount() {
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return
        }
    }
    // ceshi(){
    //     document.getElementsByClassName('comment_text')[0].innerHTML = document.getElementsByClassName('comment_text')[0].innerHTML  + '<a>这是A标签</a>'
    // }   
    handleTitle = (e) => {
        this.setState({ commentTitle: e.target.value }, () => {
        })
    }
    handleText = (e) => {
        this.setState({ Textarea: e.target.value }, () => {
            if (this.state.Textarea.length >= 1 && this.state.Textarea.length <= 499) {
                this.setState({ showTextTips: false })
            } else { this.setState({ showTextTips: true },()=>{
                setTimeout(() => {
                    this.setState({showTextTips:false})
                }, 3000);
            }) }
        })
    }
    handleDelectPicture = (index) => {
        this.setState({ showImageLimitTips: false })
        let { image } = this.state
        image.splice(index, 1)
        this.setState({ image })
    }
    handlePictureSelect = () => {
        const { image } = this.state
        this.setState({ showImageLimitTips: false, showImageSizeTips: false })
        let files = document.getElementById('selectPicture').files;
        let imageName = []
        let showImageSizeTips = false
        for (let i = 0; i < files.length; i++) {
            if (files[i].size > 2097152) {
                showImageSizeTips = true
                break
            }
        }
        if (showImageSizeTips) {
            this.setState({ showImageSizeTips: true },()=>{
                setTimeout(() => {
                    this.setState({showImageSizeTips:false})
                }, 3000);
            })
        } else if ((files.length + image.length) > 3) {
            this.setState({ showImageLimitTips: true },()=>{
                setTimeout(() => {
                    this.setState({showImageLimitTips:false})
                }, 3000);
            })
        } else {
            if (files.length >= 1) {
                for (let i = 0; i < files.length; i++) {
                    imageName.push(files[i].name)
                }
                this.setState({ imageName })
            }
            let readerFiles = image
            for (let intI = 0; intI < files.length; intI++) {
                let tmpFile = files[intI];
                let reader = new FileReader();
                reader.readAsDataURL(tmpFile);
                reader.onload = (e) => {
                    readerFiles.push([e.target.result])
                    this.setState({ image: readerFiles }, () => {
                    })
                };
            }
        }
        this.fileBtnRef.value = ''
        if (this.fileBoxRef)
            this.fileBoxRef.value = ''
    }


    AttchPost = () => {
        let { image,attchIndex, attchParams,nid,uploadImageload,uploadFailure,uploadSuccess,buttonLoad,buttonImgLoad} = this.state
        uploadFailure[attchIndex] = false
        uploadImageload[attchIndex] = true
        this.setState({uploadFailure,uploadImageload})
        this.props.getAttachPost([attchParams[attchIndex]], nid, attchRes => {
            // if (attchRes) {
            //     buttonImgLoad[attchIndex] = false
            //     if (!buttonImgLoad.includes(true)) {
            //         this.setState({ buttonLoad: false })
            //     }
            // }
            if (attchRes.result == 'success') {
                uploadImageload[attchIndex] = false
                uploadFailure[attchIndex] = false
                uploadSuccess[attchIndex] = true
                attchIndex = attchIndex +  1
                this.setState({ uploadImageload, uploadSuccess, uploadFailure ,attchIndex}, () => {
                    if(attchIndex < image.length) this.AttchPost()
                    if (!uploadSuccess.includes(false)) {
                        setTimeout(() => {
                            if (attchRes) {
                                buttonImgLoad[attchIndex] = false
                                if (!buttonImgLoad.includes(true)) {
                                    this.setState({ buttonLoad: false })
                                }
                            }
                            this.props.onClose()
                            this.props.getPostList()
                        }, 500);
                    }
                })
            }else {
                uploadImageload[attchIndex] = false
                uploadFailure[attchIndex] = true
                uploadSuccess[attchIndex] = false
                this.setState({uploadImageload:[false,false,false], uploadSuccess, uploadFailure, buttonLoad:false})
            }
        })
    }

    getSendPostRequst = () => {
        const { Textarea, image, commentTitle, nid,} = this.state
        const { marketParams } = this.props
        if (Textarea.length <= 0 || Textarea.length >= 500) {
            this.setState({ showTextTips: true },()=>{
                setTimeout(() => {
                    this.setState({showTextTips:false})
                }, 3000);
            })
        } else if (!nid) {
            this.setState({ showTextTips: false, buttonLoad: true, uploadSuccess: [false, false, false], uploadFailure: [false, false, false], })
            const params = {
                type: PARAMS.MARKET_COMMENT_POST,
                body: Textarea,
                title: commentTitle,
                instrument: marketParams.stockCode + ':' + marketParams.marketID,
                versiontype: 'Services-Content-Create-Version',
                versionnum: '1.1'
            }
            this.props.getPostNid(params, res => {
                if (res) {
                    this.setState({ nid: res.result.nid })
                    if (image.length < 1) {
                        this.props.onClose()
                        this.props.getPostList()
                        this.setState({ buttonLoad: false })
                    }
                    else {
                        this.setState({ uploadImageload: [true, true, true] })
                        let uploadSuccess = []
                        let attchParams = []
                        let buttonImgLoad = []
                        for (let i = 0; i < image.length; i++) {
                            buttonImgLoad[i] = true
                            uploadSuccess[i] = false
                            attchParams.push({
                                name: 'field_posts_file',
                                file: image[i][0],
                                [WINVEST_PARAMS_JSON_FLAG.KEY]: WINVEST_PARAMS_JSON_FLAG.VALUE,
                                versiontype: 'Services-File-Attach-Version',
                                versionnum: '1.1'
                            })
                        }
                        this.setState({attchParams,buttonImgLoad,uploadSuccess},()=>{
                            this.AttchPost()
                        })
                    }
                }
            })
        } else {
            this.AttchPost()
        }
    }
}


export default connect(state => ({
    language: state.app.language,
    theme: state.app.theme,
    marketParams: state.trade.marketParams,
}), dispatch => ({
    getPostNid: (p, c) => dispatch(userActions.getMarketPostAction(p, c)),
    getAttachPost: (p, n, c) => dispatch(userActions.getMarketAttachPostAction(p, n, c))
}))(CommentPostDialog)